<template>
    <CRow class="justify-content-center">
        <CCol xl="11" lg="11">
            <div>
                <div class="mb-5">
                    <div class="ml-1 mr-1 ml-md-4 ml-lg-5 mr-md-4 mr-lg-5">
                        <div v-if="!isAuthenticated">
                            <h1 class="text-center mb-1">Choose A Plan That Works For You...</h1>
                            <p class="text-center mb-2">
                                ...or don't. You don't have to pick right now.<br>
                                Start a Free plan with a 7-day trial that includes 10 analyses from the Team Pro plan—no credit card required.<br>
                            </p>
                        </div>
                        <p class="text-center" v-if="!isAuthenticated">
                            <a href="/login" class="btn btn-info btn-lg">Start for FREE</a>
                        </p>
                        <div v-if="isSubscribed">
                            <h3 class="text-center">
                                Your current plan is
                                <strong>{{currentProductName}}</strong> with
                                <strong>{{currentInterval}}ly</strong> subscription
                            </h3>
                        </div>
                        <CRow class="filters justify-content-center mb-4 mt-4 font-lg">
                            <div class="d-flex align-items-center">
                                <span class="filter-label text-right">Personal</span>
                                <CSwitch
                                    class="period-switcher ml-2 mr-2"
                                    color="info"
                                    shape="pill"
                                    :checked.sync="isTeam"
                                />
                                <span class="filter-label">Team</span>
                            </div>
                            <div class="d-flex align-items-center">
                                <span class="filter-label text-right">Monthly</span>
                                <CSwitch
                                    class="period-switcher ml-2 mr-2"
                                    color="info"
                                    shape="pill"
                                    :checked.sync="isYearFilter"
                                />
                                <span class="filter-label" v-if="percentsOff > 0">
                                    Yearly
                                    <span class="label-discount">Save&nbsp;up&nbsp;to&nbsp;{{ percentsOff }}%</span>
                                </span>
                            </div>
                        </CRow>
                        <CRow class="plans justify-content-center mb-5 mt-5" v-if="isLoading">
                            <CSpinner/>
                        </CRow>
                        <CRow class="plans justify-content-center mb-2" v-if="!isLoading">
                            <CCol xl="4" sm="6" col="12" v-for="product in getProducts()" v-bind:key="product.id">
                                <CCard
                                    :class="'h-100 position-relative ' + (getProductStatus(product.id) ? 'product-active' : '')">
                                    <div
                                        v-if="getRibbonText(product)"
                                        class="ribbon"
                                    ><span>{{ getRibbonText(product) }}</span></div>
                                    <CCardHeader class="plan-header">
                                        <h2 class="text-center">{{ product.name }}</h2>
                                        <div class="text-center"><small>{{ getProductDescription(product) }}</small>
                                        </div>
                                    </CCardHeader>
                                    <CCardBody>
                                        <CCardText class="plan-description">
                                            <div v-for="price in preparePrices(product.prices)" v-bind:key="price.id"
                                                 :class="price.id">
                                                <div class="mb-3">

                                                    <div class="price text-center mb-3">
                                                        <sup>{{ getCurrency(price) }}</sup>
                                                        <span class="price-number">{{ getMonthlyAmount(price) }}</span>
                                                        <sub>/{{ getInterval(price) }}</sub>
                                                        <div class="text-center price-subtitle">
                                                            <small>{{
                                                                    isYearFilter && getAmount(price) !== 0
                                                                        ? `Billed at $${getAmount(price)}/year`
                                                                        : '\xa0'
                                                                }}</small>
                                                        </div>
                                                    </div>

                                                    <p class="text-center" v-if="isAuthenticated">
                                                        <CButton
                                                            v-if="product.disabledButton && !isSubscribed"
                                                            disabled="disabled"
                                                            color="secondary"
                                                            size="lg"
                                                        >{{product.disabledButton}}
                                                        </CButton>
                                                        <CButton
                                                            v-else-if="!activePriceIds.includes(price.id)"
                                                            @click="buyProductByPrice(price)"
                                                            :disabled="price.status!=='active'"
                                                            :color="price.status==='active' ? 'info' : 'secondary'"
                                                            size="lg"
                                                        >
                                                            {{ isUpgrade(price) ? 'Upgrade' : 'Downgrade' }}
                                                        </CButton>
                                                        <CButton
                                                            v-else-if="isActionScheduled(price.id)"
                                                            color="danger"
                                                            @click="restoreSubsciption(price.id)"
                                                            size="lg"
                                                        >Cancel Schedule
                                                        </CButton>
                                                        <CButton
                                                            v-else
                                                            color="danger"
                                                            @click="askForCancelSubscription(price)"
                                                            size="lg"
                                                        >Cancel
                                                        </CButton>
                                                    </p>
                                                </div>

                                                <div class="mb-3" v-if="getProductStatus(null, price.id)">
                                                    <CRow>
                                                        <CCol class="text-center">
                                                            Status:
                                                            <strong class="text-uppercase">{{ getProductStatus(product.id) }}</strong>
                                                        </CCol>
                                                    </CRow>
                                                    <CRow v-if="getProductSchedule(null, price.id)">
                                                        <CCol class="text-center">
                                                            <strong class="text-uppercase">
                                                                {{ getProductSchedule(product.id).action}}
                                                            </strong>
                                                            scheduled
                                                            <span v-if="getProductSchedule(product.id).effectiveAt">
                                                                <br>at
                                                                <span class="text-nowrap">
                                                                    <strong>{{ formatDateTime(getProductSchedule(product.id).effectiveAt) }}</strong>
                                                                </span>
                                                            </span>
                                                        </CCol>
                                                    </CRow>
                                                </div>
                                            </div>

                                            <div v-html="product.description"></div>

                                        </CCardText>
                                    </CCardBody>
                                </CCard>
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol>
                                <p class="pl-2 pr-2 text-center d-none">
                                    Displayed prices are for yearly subscriptions, paid in full at the time of
                                    purchase. Additional subscription periods are available.
                                </p>
                                <p class="pl-2 pr-2 text-center font-lg">
                                    <strong>
                                        Try RowerUp for 14 days and if you are not 100% satisfied, get your money back.
                                    </strong>
                                </p>
                                <p class="pl-2 pr-2 text-center font-lg">
                                    <strong>
                                        Would you like to customize, gain access to 8+, or obtain raw data? An Unlimited plan is available.<br>
                                        Contact us <a href="mailto:info@rowerup.com">info@rowerup.com</a>
                                    </strong>
                                </p>
                            </CCol>
                        </CRow>
                    </div>
                </div>
            </div>
        </CCol>

        <ModalConfirm v-bind="modal" @update:show="() => modal={}"/>
        <BillingAddressModal v-if="isAuthenticated"/>

    </CRow>
</template>

<script>
import {
    openCheckout,
    getProducts,
    cancelSubscription,
    subscriptionScheduleReset,
    updateSubscriptionPrice,
    editTransactionCheckout,
    loadPaddle
} from '@/scripts/paddle'
import {store} from '@/scripts/globals'
import {formatDateTime} from '@/scripts/utils';
import {settings} from '@/scripts/queries';
import ModalConfirm from "@/components/ModalConfirm.vue";
import BillingAddressModal from "@/components/BillingAddressModal.vue";
import subscription from "@/mixins/subscription";

const freeTier = {
    "id": "free",
    "name": "Free",
    "description": "Details",
    "disabledButton": "Always Applied", //Used for the button text
    "custom_data": {
        "sort": "0",
        "filter": "0",
        "description": " "
    },
    "status": "active",
    "prices": [
        {
            "id": "free_monthly",
            "product_id": "free",
            "description": "$0",
            "name": null,
            "billing_cycle": {
                "interval": "month",
                "frequency": 1
            },
            "unit_price": {
                "amount": "0",
                "currency_code": "USD"
            },
            "status": "active",
        },
        {
            "id": "free_yearly",
            "product_id": "free",
            "description": "$0",
            "name": null,
            "billing_cycle": {
                "interval": "year",
                "frequency": 1
            },
            "unit_price": {
                "amount": "0",
                "currency_code": "USD"
            },
            "status": "active",
        },
    ]
};

export default {
    mixins: [subscription],
    components: {
        ModalConfirm,
        BillingAddressModal
    },
    props: {
        isAuthenticated: Boolean
    },
    data() {
        return {
            isLoading: true,
            store,
            products: [],
            isYearFilter: true,
            isTeam: false,
            modal: {},
            formatDateTime,
        }
    },
    methods: {
        buyProductByPrice(price) {
            let product = this.getProductByPrice(price)
            if (product?.id === 'free' && this.currentPrice) {
                this.askForCancelSubscription(this.currentPrice)
            } else if (this.isSubscribed) {
                this.askForUpdateSubscription(price.id);
            } else {
                openCheckout(price.id, this.getUserId, this.getUserEmail);
            }
        },
        async freeTier() {
            let tier = freeTier;
            let settingsData = await settings();
            tier.name = settingsData.freeTierName
            tier.custom_data.description = settingsData.freeTierSubtitle
            tier.disabledButton = settingsData.freeTierButton ? settingsData.freeTierButton : tier.disabledButton
            tier.description = settingsData.freeTierDescription
            return tier;
        },
        async loadProducts() {
            let products = await getProducts();
            products.push(await this.freeTier());

            products.map((product) => {
                product.prices.sort((priceA, priceB) => {
                    const sortA = priceA.custom_data?.sort,
                        sortB = priceB.custom_data?.sort;
                    if (sortA < sortB) {
                        return -1;
                    } else if (sortA > sortB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
            });

            this.products = products.sort((productA, productB) => {
                const sortA = Number(productA.custom_data?.sort),
                    sortB = Number(productB.custom_data?.sort);
                if (productA.id === 0) {
                    return -1;
                } else if (productB.id === 0) {
                    return 1;
                } else if (sortA < sortB) {
                    return -1;
                } else if (sortA > sortB) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        preparePrices(prices) {
            prices = prices.filter((price) => {
                return (this.isYearFilter && (price.billing_cycle?.interval === 'year' || !price.billing_cycle?.interval))
                    || (!this.isYearFilter && price.billing_cycle?.interval !== 'year')
            });

            return prices;
        },
        getProducts() {
            return this.products.filter((product) => {
                const filter = Number(product?.custom_data?.filter ?? 0)
                return (this.isTeam && filter !== 0)
                    || (!this.isTeam && filter === 0);
            });
        },
        getProductByPrice(price){
            return this.products?.find((product) => {
                return Boolean(product?.prices?.find((productPrice) => productPrice.id === price?.id));
            });
        },
        getPriceById(findPriceId) {
            let price = undefined;
            this.products?.forEach((product) => {
                let priceFound = product?.prices?.find((productPrice) => productPrice.id === findPriceId);
                if (priceFound) {
                    price = priceFound;
                }
            });
            return price;
        },
        getProductSubscription(productId = null, priceId = null) {
            const subs = this.subscriptions;
            let productSub = undefined;
            if (!subs.length) {
                return productSub;
            }
            subs.forEach((sub) => {
                if ((productId && productId === sub.extProductId) || (priceId && priceId === sub.extPriceId)) {
                    productSub = sub;
                }
            });
            return productSub;
        },
        getProductStatus(productId = null, priceId = null) {
            return this.getProductSubscription(productId, priceId)?.status ?? '';
        },
        getProductSchedule(productId = null, priceId = null) {
            const scheduledChange = this.getProductSubscription(productId, priceId)?.scheduledChange;
            return scheduledChange?.action ? scheduledChange : undefined;
        },
        isActionScheduled(priceId) {
            return this.getProductSchedule(null, priceId)?.action;
        },
        isUpgrade(price) {
            return this.currentPlanAmount <= this.getAmount(price);
        },
        getAmount(price) {
            return (price?.unit_price?.amount ?? 0) / 100;
        },
        getMonthlyAmount(price) {
            const resultPrice = (price?.unit_price?.amount ?? 0) / 100;
            return price?.billing_cycle?.interval === 'year' ? Math.round((resultPrice / 12) * 100) / 100 : resultPrice;
        },
        getInterval(price) {
            return price?.billing_cycle?.interval ? 'month' : 'one time';
        },
        getCurrency(price) {
            const currencies = {
                'usd': '$',
                'eur': '€'
            };
            const code = price?.unit_price?.currency_code?.toLowerCase() ?? '';
            return currencies[code] ? currencies[code] : code.toUpperCase();
        },
        getTrialPeriod(price) {
            const freq = price?.trial_period?.frequency ?? 0;
            let interval = price?.trial_period?.interval ?? '';
            if (freq > 1) {
                interval += 's';
            }
            return freq ? freq + ' ' + interval : '';
        },
        getRibbonText(product) {
            return product?.custom_data?.ribbon ?? '';
        },
        getProductDescription(product) {
            return product?.custom_data?.description ?? ' ';
        },
        askForCancelSubscription(price) {
            const sub = this.getSubscriptionByPriceId(price.id);
            if (!sub) {
                console.error('Subscription for cancel not found');
                return;
            }

            let message = '';
            if (this.isActionScheduled(price.id)) {
                const canceledAt = formatDateTime(this.getProductSchedule(null, price.id).effectiveAt);
                message = `Your subscription is scheduled to be canceled on ${canceledAt}. After that,
                    you will automatically be moved to the Free Plan.`;
            } else {
                const endsAt = this.getSubscriptionEndsAt(sub);
                message = `Are you sure you want to cancel your current '${this.currentProductName} (${this.currentInterval})' subscription?
                    Please note that if you confirm, your subscription will be scheduled to be canceled on ${endsAt}.
                    After that, you will automatically be moved to the Free Plan.`;
            }

            this.modal = {
                show: true,
                question: message,
                color: 'danger',
                title: 'Cancel Subscription',
                okCallback: this.cancelPriceSubscription,
                data: {sub: sub}
            };
        },
        async cancelPriceSubscription(data) {
            return await cancelSubscription(data.sub.extId);
        },
        askForUpdateSubscription(priceId) {
            const intervalFrom = this.currentInterval,
                priceTo = this.getPriceById(priceId),
                intervalTo = priceTo?.billing_cycle?.interval,
                from = this.currentProduct?.name ?? '',
                to = this.getProductByPrice(priceTo)?.name ?? '';

            this.modal = {
                show: true,
                question: 'Are you sure you want to change your subscription'
                    + (from ? ` from "${from} (${intervalFrom}ly)"` : '')
                    + (to ? ` to "${to} (${intervalTo}ly)"` : '') + '?',
                color: 'info',
                title: 'Change Subscription',
                okCallback: this.updateSubscription,
                data: {priceId: priceId}
            };
        },
        updateSubscription(data) {
            const priceId = data.priceId;
            updateSubscriptionPrice(priceId);
        },
        async restoreSubsciption(priceId) {
            const filteredSubs = this.subscriptions?.filter((sub) => {
                return sub.extPriceId === priceId;
            })
            if (!filteredSubs || filteredSubs.length === 0) {
                return;
            }

            await subscriptionScheduleReset(filteredSubs[0].extId);
        },
        setFilterValues() {
            if (this.currentInterval === 'month') {
                this.isYearFilter = false;
            }
            if (Number(this.currentProduct?.custom_data?.filter) === 1) {
                this.isTeam = true;
            }
        },
        getSubscriptionByPriceId(priceId) {
            const subs = this.subscriptions;
            if (!Array.isArray(subs)) {
                return false;
            }
            const filteredSubs = subs.filter((sub) => {
                return sub.extPriceId === priceId;
            })

            if (filteredSubs.length === 0) {
                return false;
            }

            return filteredSubs[0];
        },
        getSubscriptionEndsAt(sub) {
            const date = sub?.endsAt;
            return date ? formatDateTime(date) : '';
        }
    },
    computed: {
        getUserEmail() {
            return this.store.myUser?.email
        },
        getUserId() {
            return this.store.myUser?.id
        },
        percentsOff() {
            const products = this.getProducts();
            let percent = 0;
            products.forEach((product) => {
                let montlyPrice = 0,
                    anualMonthlyPrice = 0;
                product?.prices?.forEach((price) => {
                    let interval = price?.billing_cycle?.interval,
                        amount = this.getMonthlyAmount(price);
                    if (interval === 'year') {
                        if (amount > anualMonthlyPrice) {
                            anualMonthlyPrice = amount;
                        }
                    } else if (interval === 'month') {
                        if (amount > montlyPrice) {
                            montlyPrice = amount;
                        }
                    }
                });
                if (montlyPrice > 0 && anualMonthlyPrice > 0) {
                    let productPercent = (1 - anualMonthlyPrice / montlyPrice) * 100;
                    if (productPercent > percent) {
                        percent = productPercent;
                    }
                }
            });

            return Math.floor(percent);
        },
        currentPlanAmount() {
            const subs = this.store.myUser?.subscriptions;
            if (subs.length > 0) {
                return Number(subs[0]?.amount / 100);
            } else {
                return 0;
            }
        },
        currentPrice() {
            return this.getPriceById(this.activePriceIds[0]);
        },
        currentProduct() {
            return this.getProductByPrice(this.currentPrice);
        },
        currentProductName() {
            return this.getProductByPrice(this.currentPrice)?.name ?? '';
        },
        currentInterval() {
            return this.currentPrice?.billing_cycle?.interval;
        }
    },
    async created() {
        this.isLoading = true;
        await this.loadProducts();
        this.isLoading = false;

        await loadPaddle();

        const txn = this.$route?.query?._ptxn;
        if (txn) {
            await editTransactionCheckout(txn);
        }

        this.setFilterValues();
    }
}
</script>

<style lang="scss">
.btn.btn-calltoaction {
    color: #fff;
    background-color: #aa4dc8;
    border-color: #aa4dc8;
}

.filters {
    column-gap: 40px;
    row-gap: 20px;
}

.filter-label {
    position: relative;
    width: 60px;
}

@media (max-width: 768px) {
    .filters {
        align-content: center;
        flex-direction: column;
    }
}

.label-discount {
    background-color: white;
    color: #39f;
    font-size: 14px;
    font-weight: 600;
    margin-left: -14px;
    position: absolute;
    left: 100%;
    padding: 2px 2px;
    white-space: nowrap;
}


.period-switcher.c-switch-info .c-switch-input + .c-switch-slider {
    background-color: #39f;
    border-color: #0080ff;
}

.ribbon {
    width: 100px;
    height: 100px;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;
}

.ribbon span {
    position: absolute;
    display: block;
    width: 167px;
    padding: 8px 0;
    background-color: #0d86ff;
    color: #fff;
    text-align: center;
    left: -15px;
    top: 15px;
    transform: rotate(45deg);
}

.plans {
    $card-height: 100%;
    row-gap: 30px;

    .product-active {
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    }

    .card, .card-header, .card-footer, .card-header:first-child, .card-footer:last-child {
        border-radius: 0.3rem;
    }

    .plan-header {
        border-bottom: 0;
        padding-top: 22px;
        padding-bottom: 0;
    }

    .plan-header h2 {
        font-size: 1.7em;
        margin-bottom: 0;
    }

    .plan-description {
        padding: 0 10%;
    }

    .plan-description strong {
        color: #0d86ff;
    }

    .plan-description li {
        list-style: inherit;
    }

    ul {
        list-style: none;
        padding-left: 0;
    }

    li {
        position: relative;
        padding-left: 1.5em;
        margin-bottom: 5px;
    }

    li:before {
        content: '';
        position: absolute;
        left: 4px;
        top: 4px;
        width: 1em;
        height: 1em;
        background: url("data:image/svg+xml;utf8,<?xml version='1.0' encoding='utf-8'?><svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24'><path fill='rgb(51, 153, 255)' d='M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z'/></svg>") no-repeat;
    }

    li.cross {
        color: #99999f;
    }

    li.cross:before {
        background: url("data:image/svg+xml;utf8,<?xml version='1.0' encoding='utf-8'?><svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24'><path fill='rgb(153, 153, 159)' d='M 20.285 0 L 12 8.3 L 3.7 0 L 0 3.7 L 8.3 12 L 0.003 20.276 L 3.7 24 L 12 15.7 L 20.3 24 L 24 20.3 L 15.7 12 L 24 3.715 L 20.285 0 Z'/></svg>") no-repeat;
    }

    .price {
        line-height: 1;
    }

    .price-number {
        font-size: 36px;
        font-weight: 900;
    }

    .price sub, .price sup {
        color: #99999f;
        font-size: 16px;
        font-weight: 100;
    }

    .price sup {
        top: -0.9em;
    }

    .price sub {
        bottom: 0;
    }

    .card-body {
        padding-bottom: 0;
    }

    small {
        font-size: 90%;
    }
}

</style>